<template>
    <!--左侧菜单栏-->
    <div class="menu">
        <div class="menu-header">
            <div class="brand">
                <div class="brand-icon">
                    <icon-home />
                </div>
                <span class="brand-text">财务管家</span>
            </div>
        </div>
        <a-menu
            theme="light"
            :collapsed="collapsed"
            v-model:selected-keys="selectedKeys"
            v-model:opened-keys="openedKeys"
            class="global-menu"
            @select="selectMenu">
            <router-link to="/dashboard">
                <a-menu-item key="/dashboard">
                    <template #icon><icon-layout /></template>
                    工作台
                </a-menu-item>
            </router-link>
            <router-link to="/payRecord">
                <a-menu-item key="/payRecord">
                    <template #icon><icon-calendar /></template>
                    支出记录
                </a-menu-item>
            </router-link>
            <router-link to="/statement">
                <a-menu-item key="/statement">
                    <template #icon><icon-bar-chart /></template>
                    支出总览
                </a-menu-item>
            </router-link>
            <router-link to="/salary">
                <a-menu-item key="/salary">
                    <template #icon><icon-gift /></template>
                    工资记录
                </a-menu-item>
            </router-link>
            <router-link to="/loanRecord">
                <a-menu-item key="/loanRecord">
                    <template #icon><icon-idcard /></template>
                    借贷记录
                </a-menu-item>
            </router-link>
            <router-link to="/todoRecord">
                <a-menu-item key="/todoRecord">
                    <template #icon><icon-check-circle /></template>
                    待办记录
                </a-menu-item>
            </router-link>
            <router-link to="/attendance">
                <a-menu-item key="/attendance">
                    <template #icon><icon-clock-circle /></template>
                    考勤打卡
                </a-menu-item>
            </router-link>
            <router-link to="/document">
                <a-menu-item key="/document">
                    <template #icon><icon-file /></template>
                    文档
                </a-menu-item>
            </router-link>
            <!-- 账号密码管理（仅ROOT管理员显示） -->
            <router-link to="/accountPassword" v-if="isRootUser">
                <a-menu-item key="/accountPassword">
                    <template #icon><icon-safe /></template>
                    账号密码管理
                </a-menu-item>
            </router-link>

            <!-- 用户管理菜单（仅ROOT用户显示） -->
            <router-link to="/userCenter" v-if="isRootUser">
                <a-menu-item key="/userCenter">
                    <template #icon><icon-user-group /></template>
                    用户管理
                </a-menu-item>
            </router-link>

            <!-- 文件与图片管理（仅ROOT用户显示） -->
            <router-link to="/fileManagement" v-if="isRootUser">
                <a-menu-item key="/fileManagement">
                    <template #icon><icon-folder /></template>
                    文件与图片管理
                </a-menu-item>
            </router-link>

        </a-menu>
    </div>
</template>

<script>
import {ref, watch, computed} from 'vue';
import {useRouter, useRoute} from 'vue-router';
import {useStore} from 'vuex';
import {
    IconHome,
    IconLayout,
    IconCalendar,
    IconBarChart,
    IconGift,
    IconIdcard,
    IconCheckCircle,
    IconClockCircle,
    IconSafe,
    IconUserGroup,
    IconFolder,
    IconFile
} from '@arco-design/web-vue/es/icon';

export default {
    name: "LeftMenu",
    components: {
        IconHome,
        IconLayout,
        IconCalendar,
        IconBarChart,
        IconGift,
        IconIdcard,
        IconCheckCircle,
        IconClockCircle,
        IconSafe,
        IconUserGroup,
        IconFolder,
        IconFile
    },
    setup() {
        // 路由实例
        const router = useRouter();
        const route = useRoute();
        const store = useStore();

        const collapsed = ref(false);
        const openedKeys = ref([]); // 二级菜单的开启状态

        const selectedKeys = ref([route.path]); // 当前默认选中的菜单

        // 判断是否为ROOT用户
        const isRootUser = computed(() => {
            const userInfo = store.getters.userInfo;
            return userInfo && userInfo.role === 'ROOT';
        });

        watch(
            () => route.path,
            (newPath) => {
                selectedKeys.value = [newPath];
            },
            {immediate: true}
        );

        // 选中菜单，跳转页面
        const selectMenu = (params) => {
            // 路由跳转（支持任意导航项）
            router.push(params);
        };

        return {
            collapsed,
            selectedKeys,
            openedKeys,
            selectMenu,
            isRootUser,
            toggleCollapse: () => {
                collapsed.value = !collapsed.value;
            },
        }
    }
};
</script>

<style scoped>
.menu {
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    background: linear-gradient(180deg, #ffffff 0%, #f8f9fc 100%);
}

.menu-header {
    padding: 20px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.brand {
    display: flex;
    align-items: center;
    gap: 12px;
}

.brand-icon {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    color: white;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.brand-text {
    font-size: 18px;
    font-weight: 700;
    color: #1d2129;
    letter-spacing: -0.5px;
}

.global-menu {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    border-right: none;
    padding: 8px;
}

.global-menu :deep(.arco-menu-item) {
    border-radius: 8px;
    margin: 2px 0;
    font-weight: 500;
}

.global-menu :deep(.arco-menu-item:hover) {
    background-color: rgba(102, 126, 234, 0.1);
    color: #667eea;
}

.global-menu :deep(.arco-menu-selected) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: white !important;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.global-menu :deep(.arco-menu-selected .arco-icon) {
    color: white !important;
}

.global-menu :deep(.arco-menu-item .arco-icon) {
    font-size: 18px;
}
</style>

<style>
/* 暗色模式：左侧菜单背景与文字 */
body[arco-theme='dark'] .menu {
    background: linear-gradient(180deg, #17171a 0%, #1d2129 100%);
}
body[arco-theme='dark'] .menu-header {
    border-bottom-color: var(--color-border-1);
}
body[arco-theme='dark'] .brand-text {
    color: var(--color-text-1);
}
body[arco-theme='dark'] .global-menu .arco-menu-item:hover {
    background-color: rgba(102, 126, 234, 0.2);
}
body[arco-theme='dark'] .global-menu .arco-menu-selected {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: white !important;
}
</style>